
import React, { useState, useEffect, useRef } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { Table, Autocomplete, TableBody, Grid, FormControlLabel, Checkbox, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useAccesos } from '../contexts/AccesosContext';


function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}



function AddObjetivo ({ handleNewObjetivo, editObjetivo, idCampania, cancelarEdicion }){
     // Estado para el título, descripción y selección del ComboBox
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [tituloObjetivo, setTituloObjetivo] = useState('');
    const [descripcionObjetivo, setDescripcionObjetivo] = useState('');
    const [tipoObjetivoSeleccionado, setTipoObjetivoSeleccionado] = useState(null);
    const [campania, setCampania] = useState([])
    const [cumplido, setCumplido] = useState(false);
    const [meta, setMeta] = useState('');
    const [resultado, setResultado] = useState('');
    const [tipoObjetivos, setTipoObjetivos] = useState([]);
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');
    const [imagePreviewUrl, setImagePreviewUrl] = useState([]);
    const [selectedImage, setSelectedImage] = useState([]);
    const fileInputRef = useRef(null);


    const { user } = useUser();
    const { tienePermiso } = useAccesos();
        // Obtener la fecha y hora actual
        function obtenerFechaISOsinZ() {
            const fecha = new Date();
            let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
            fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
            return fechaISO;
    }
     
        const fetchTiposObjetivo = async () => {
                try {
                    const response = await fetch(`${server}/CrmTipoObjetivoCampaniums`);
                    const data = await response.json();
                    setTipoObjetivos(data.$values);
                } catch (error) {
                    console.error('Error al cargar los estados de campania:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar los Estados de campania: ' + error,
                    });
                }
            };  
             

        useEffect(() => {
              fetchTiposObjetivo();
            }, []);
        // Convertir a una cadena en formato ISO 8601
        const fechaFormateada = obtenerFechaISOsinZ();
        // Carga inicial de datos si estamos en modo edición
        useEffect(() => {
            if (editObjetivo && tipoObjetivos.length) {
                setTituloObjetivo(editObjetivo.tituloObjetivo);
                setDescripcionObjetivo(editObjetivo.decripcionObjetivo); // Cargar la descripción de la raza para editar
                
                const tipoObjetivoMatch = tipoObjetivos.find(e => e.id === editObjetivo.idTipoObjetivo);
                
                setTipoObjetivoSeleccionado(tipoObjetivoMatch || null);
                setMeta(editObjetivo.meta);
                
                setResultado(editObjetivo.resultado || '' );
                // setCampania(editObjetivo.idCampania);
                setCumplido(editObjetivo.cumplido || false);
                setModificacion(2);
                setIngresadoPor(editObjetivo.ingresadoPor);
                loadObjetivoParaEditar(editObjetivo.idObjetivo, editObjetivo.idCampania);
    
            } else {
                setTituloObjetivo('');
                setDescripcionObjetivo(''); // Resetear la descripción si no estamos editando
                setTipoObjetivoSeleccionado(null);
                setMeta('');
                setResultado('');
                setCampania('');
                setCumplido(false);
                setModificacion(1);
                setIngresadoPor('');
    
            }
        }, [editObjetivo]);
 

        const loadObjetivoParaEditar = async (idObjetivo, idCampania) => {
            try {
                const response = await fetch(`${server}/CrmEvidenciasCampaniums/objetivo/${idObjetivo}/campania/${idCampania}/evidencias`);
                if (response.ok) {
                    const data = await response.json();

                    const evidencias = data.$values || [];

                        const images = evidencias.map(e => ({
                            id: e.id,
                            urlEvidencia: e.urlEvidencia,
                            file: null
                }));
                        // setImagePreviewUrl(urls);


                        setImagePreviewUrl(images);
                        // setSelectedImage([]); // no hay archivos reales en este punto
                   
                } else {
                    const errorText = await response.text();
                    console.error("Error al obtener evidencias:", errorText);
                }
            } catch (error) {
                console.error("Error cargando evidencias:", error);
            }
        };

        const handleRemoveImage = async (indexEliminar) => {
            const imagenBorrar = imagePreviewUrl[indexEliminar];

            // if (imagenBorrar?.id && imagePreviewUrl.id !== 0) {

            const result = await Swal.fire ({
                title: 'Estas seguro?',
                text: 'Desea eliminar esta evidencia?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
            });

            if (!result.isConfirmed) return;

            if (imagenBorrar.id === 0) {
                // console.warn ("La imagen no tiene un ID válido para eliminar", imagenBorrar);

                if (imagenBorrar.urlEvidencia?.startsWith('blob:')) {
                    URL.revokeObjectURL(imagenBorrar.urlEvidencia);
                }

                    setImagePreviewUrl(prev => prev.filter((_, i) => i !== indexEliminar));
                 
                return;

            }
                try {
                     const username = ''+user.codigoUsuario+'/';
        
                    const response = await fetch(`${server}/CrmEvidenciasCampaniums/${imagenBorrar.id}/${username}`,{
                        method: 'DELETE'
                    });

                    if (response.ok) {

                        setImagePreviewUrl(prev => prev.filter((_, i) => i !== indexEliminar));

                            Swal.fire({
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Objetivo eliminado con éxito',
                        });
                    } else {
                        const errorText = await response.text();
                        // console.error('Error al eliminar la imagen:', errorText);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: `No se pudo eliminar la imagen: ${response.statusText}`
                        });
                    }
                } catch (error) {
                    console.error('Error al eliminar el objetivo:', error);
                        Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al eliminar el objetivo: ' + error,
                    }); 
                }
            
    };
 
     // Manejo del formulario
        const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editObjetivo? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editObjetivo ? `${server}/CrmObjetivoCampaniums/${editObjetivo.idObjetivo}` : `${server}/CrmObjetivoCampaniums`;
    
            const objetivo = { 
                idObjetivo:editObjetivo ? editObjetivo.idObjetivo:0,
                tituloObjetivo,
                decripcionObjetivo: descripcionObjetivo,
                idTipoObjetivo: tipoObjetivoSeleccionado?.id || null,
                idCampania,
                meta,
                ...(resultado !== '' && { resultado }), 
                cumplido,
                IngresadoPor: !editObjetivo ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editObjetivo ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                modificacion,
                fechaIngreso: fechaFormateada
            };

            Object.keys(objetivo).forEach(key => objetivo[key] === undefined && delete objetivo[key]);
            
            // console.log(endpoint)
    

            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(objetivo),
                });
    
                if (response.ok) {
                    const text = await response.text();
                    const data = text ? JSON.parse(text) : {};

                    const objetivoId = editObjetivo
                        ? editObjetivo.idObjetivo
                        : data.idObjetivo || data.Id || data.id; // revisa cuál te retorna tu backend

                    const nuevas = imagePreviewUrl.filter(img => img.id === 0 && img.file);
                    // ✅ Si hay imagen seleccionada, subirla ahora


                    if (nuevas.length && objetivoId) {
                        const formData = new FormData();
                        nuevas.forEach(img => formData.append('files', img.file));

                        formData.append('idCampania', idCampania);
                        formData.append('idEntidad', objetivoId);
                        formData.append('tipoEntidad', 'objetivo');
                        formData.append('usuario', user.codigoUsuario);

                
                        await fetch(`${server}/CrmEvidenciasCampaniums/upload`, {
                        method: 'POST',
                        body: formData,
                
                        });

                        
                    }

                    imagePreviewUrl.forEach(img => {
                        if(img.urlEvidencia?.startsWith('blob:')) {
                            URL.revokeObjectURL(img.urlEvidencia);
                        }
                    });

                    setImagePreviewUrl([]);
                    if(fileInputRef.current) fileInputRef.current.value = '';

                    setTituloObjetivo('');
                    setDescripcionObjetivo(''); // Resetear la descripción si no estamos editando
                    setTipoObjetivoSeleccionado(null);
                    setMeta('');
                    setResultado('');
                    setCampania('');
                    setCumplido(false);
                    setModificacion(1);
                    setIngresadoPor('');

                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                    handleNewObjetivo();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar el objetivo',
                    text: error.message || 'Ocurrió un error inesperado',
                });        }
        };
 
        const handleCancelarEdicion = () => {
            setTituloObjetivo('');
            setDescripcionObjetivo(''); // Resetear la descripción si no estamos editando
            setTipoObjetivoSeleccionado(null);
            setMeta('');
            setResultado('');
            setCampania('');
            setCumplido(false);
            setModificacion(1);
            setIngresadoPor('');
            setImagePreviewUrl([]);
            if(fileInputRef.current) fileInputRef.current.value = '';
            if (cancelarEdicion) cancelarEdicion();

        }

    return (
        <>
        <h2>{editObjetivo ? 'Editar Objetivo' : 'Agregar Nuevo Objetivo'}</h2>
        <br />
        <form onSubmit={handleSubmit} className="form-horizontal form-label-left" >
            <div className="item form-group">
            <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="nombreObjetivo">
                    Nombre: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="nombreObjetivo"
                        required="required"
                        className="form-control"
                        value={tituloObjetivo}
                        onChange={(e) => setTituloObjetivo(e.target.value)}
                    />
                </div>
                <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="descripcionObjetivo">
                    Descripción: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="descripcionObjetivo"
                        required="required"
                        className="form-control"
                        value={descripcionObjetivo}
                        onChange={(e) => setDescripcionObjetivo(e.target.value)}
                    />
                </div>
            </div>

              {/* ComboBox con Búsqueda (Autocomplete) */}
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="tipoObjetivo">
                        Tipo de objetivo: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={tipoObjetivos}
                            getOptionLabel={(option) => option.tipoObjetivo || ''}
                            value={tipoObjetivoSeleccionado}
                            onChange={(event, newValue) => setTipoObjetivoSeleccionado(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.label === value.label}
                            disableClearable
                        />
                    </div>
                   <label className="col-form-label col-md-2 col-sm-3 label-align"
                    htmlFor="meta">
                    Meta: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="meta"
                        required
                        className="form-control"
                        placeholder="Ingrese solo números"
                        value={meta}
                        pattern="[0-9]*"         // Refuerza validación de solo números
                        onChange={(e) => {
                        // Solo permite números
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        setMeta(value);
                        }}
                    />
                    </div>
                                    
            
                </div>
                 <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align">
                        Evidencias (imágenes):
                    </label>
                    <div className="col-md-10 col-sm-9">
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            ref={fileInputRef}
                            onChange={(e) => {
                                const files = Array.from(e.target.files);

                                const newImages = files.map(file => ({
                                    id: 0,
                                    urlEvidencia: URL.createObjectURL(file),
                                    file: file,

                                }));

                                setImagePreviewUrl (prev => [...prev, ...newImages]);

                            }}
                        />
                    </div>
                </div>

                {imagePreviewUrl && imagePreviewUrl.length > 0 && (
                <div className="form-group row mt-2">
                    {imagePreviewUrl.map((img, index) => (
                        <div key={index} className="col-md-2 mb-2 position-relative">
                            <img
                                src={img.urlEvidencia}
                                alt={`Evidencia ${index}`}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                }}
                            />
                            <button
                                type="button"
                                onClick={() => handleRemoveImage(index)}
                                style={{
                                    position: 'absolute',
                                    top: '2px',
                                    right: '2px',
                                    background: 'rgba(255, 0, 0, 0.7)',
                                    border: 'none',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '24px',
                                    height: '24px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                }}
                                title="Eliminar imagen"
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            )}
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="cumplido">
                        Cumplido:
                    </label>
                    {/* Checkbox en su columna alineado */}
                    <div className="col-md-4 col-sm-3 d-flex align-items-center">
                        <Checkbox
                        checked={cumplido}
                        onChange={(e) => setCumplido(e.target.checked)}
                        />
                    </div>
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="meta">
                        Resultado : <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <input
                            type="text"
                            id="meta"
                            className="form-control"
                            value={resultado}
                            onChange={(e) => setResultado(e.target.value)}
                        />
                    </div>
                </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Objetivo')}>
                        {editObjetivo ? 'Actualizar' : 'Guardar'}
                    </button>
                    {editObjetivo && (
                        <button type="button" className="btn btn-secondary" onClick={handleCancelarEdicion}>
                            Cancelar
                        </button>  
                    )}
                </div>
            </div>
        </form>
    </>
    )
}


export default AddObjetivo;